import React from 'react';
import StarDistributionChart from '../../../pages/user-profile-dashboard/components/StarDistributionChart';
import ScoreSystemCard from './ScoreSystemCard';
import MobileStatisticsList from './MobileStatisticsList';
import StatisticsGrid from './StatisticsGrid';
import ProgressTrendCard from './ProgressTrendCard';
import AttendanceCard from './AttendanceCard';
import RecentProofsSection from './RecentProofsSection';

const OverviewGoalsSection = ({
  levelInfo,
  score,
  statistics,
  safeTrendValue,
  trendMode,
  setTrendMode,
  trendYear,
  setTrendYear,
  availableTrendYears,
  weeklyTabs,
  trendWeekIndex,
  setTrendWeekIndex,
  monthlyTrendDataByYear,
  weeklyTrendData,
  starDistribution,
  streakData,
  lastAttendanceText,
  recentProofs,
  onOpenProofDetail,
  isLoading,
  hasMore,
  observerTarget,
}) => {
  return (
    <>
      <ScoreSystemCard levelInfo={levelInfo} score={score} />

      <MobileStatisticsList statistics={statistics} />
      <StatisticsGrid statistics={statistics} safeTrendValue={safeTrendValue} />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        <div className="lg:col-span-2">
          <ProgressTrendCard
            trendMode={trendMode}
            setTrendMode={setTrendMode}
            trendYear={trendYear}
            setTrendYear={setTrendYear}
            availableTrendYears={availableTrendYears}
            weeklyTabs={weeklyTabs}
            trendWeekIndex={trendWeekIndex}
            setTrendWeekIndex={setTrendWeekIndex}
            monthlyTrendDataByYear={monthlyTrendDataByYear}
            weeklyTrendData={weeklyTrendData}
          />
        </div>
        <div>
          <StarDistributionChart distribution={starDistribution} />
        </div>
      </div>

      <AttendanceCard
        streakData={streakData}
        lastAttendanceText={lastAttendanceText}
        monthlyCountText={`${safeTrendValue?.proofs}회`}
      />

      <RecentProofsSection
        recentProofs={recentProofs}
        onOpenDetail={onOpenProofDetail}
        isLoading={isLoading}
        hasMore={hasMore}
        observerTarget={observerTarget}
      />
    </>
  );
};

export default OverviewGoalsSection;
